import React, { useCallback, useEffect } from 'react'
import context from '@/context'
import { ValidationBoundary } from '@/components/validation'
import { ModalBody, Row } from 'reactstrap'
import { BasicHeader } from '@/dialogs/common/basicHeader'
import { FormLoader, FormRow } from '@/components/changeRequests'
import { ValidDates } from '@/components/changeRequests/common/validDates'
import { ChangeItemDialogFooter } from '@/dialogs/common/changeItemDialogFooter'
import { PersonSelection } from '@/components/demographics/personSelection'
import { usePropertyReader } from '@/hooks/usePropertyReader'
import { openErrorDialog } from '@/utils/dialogHelpers'
import LoadingIndicator from '@/components/LoadingIndicator'
import { usePropertySetter } from '@/hooks/usePropertySetter'
import { decimalMaxChangeItemValue } from '@/utils/constants'

function RelatedPersonDialog (props) {
  return (
    <FormLoader {...props} render={() => <RelatedPersonForm {...props} />} />
  )
}

const RelatedPersonForm = React.memo(function RelatedPersonForm (props) {
  const { value, target } = props
  const isReadonly = value && value.relatedPersonType && value.relatedPersonType.code === 'Brnmngr'
  const [relatedPersonType, personType] = usePropertyReader(['relatedPersonType', 'personType'])
  const setRelatedPersonType = usePropertySetter('relatedPersonType',
    (prop, value) => (prop || {}).code === (value || {}).code)

  useEffect(() => {
    if (personType === 10) {
      context.cache.getRelatedPersonTypes()
        .then(r => {
          const boardMember = r.find(x => x.code === 'Brdm')
          setRelatedPersonType(boardMember)
        })
        .catch(() => openErrorDialog())
    }
  }, [personType, setRelatedPersonType])

  const relatedPersonTypeDataSource = useCallback((request, options) => {
    return context.cache.getRelatedPersonTypes(request, options)
      .then(r => r.filter(x => x.code === 'Brdm'))
  }, [])

  return (
    <ValidationBoundary>
      <BasicHeader title='Institutions.RelatedPerson' {...props} readonly={isReadonly} />
      <ModalBody>
        <Row>
          <div className='col-12'>
            {context.isInternalApp() && <PersonSelection personId={props.personId} readonly={isReadonly || context.isReportApp()} required target={target} />}
            {personType && personType === 10
              ? <React.Fragment>
                {relatedPersonType
                  ? <FormRow label='Institutions.RelatedPersonType' name='relatedPersonType' target={target} inputType='dropdown' clientSide dataSource={relatedPersonTypeDataSource} required />
                  : <LoadingIndicator inline />}
                <FormRow label='Institutions.CompanyName' name='companyName' target={target} inputType='text' required inputProps={{ maxLength: 256 }} />
                <FormRow label='Institutions.GeneralManagerName' name='generalManagerName' target={target} inputType='text' required inputProps={{ maxLength: 256 }} />
                <FormRow label='Institutions.CompanyAddress' name='companyAddress' target={target} inputType='text' required inputProps={{ maxLength: 256 }} />
                <FormRow label='Institutions.AuthorizedBy' name='authorizedBy' target={target} inputType='text' required inputProps={{ maxLength: 256 }} />
                <FormRow label='Institutions.IndustrySector' name='industrySector' target={target} inputType='text' required inputProps={{ maxLength: 256 }} />
                <FormRow label='Institutions.CompanyCapital' name='companyCapital' target={target} inputType='text' required inputProps={{ maxLength: 256 }} />
                <FormRow label='Institutions.InvestmentInBankCapitalRatio' name='investmentInBankCapitalRatio' target={target} inputType='number' required inputProps={{ min: 0 }} />
                <ValidDates readonly={isReadonly} />
              </React.Fragment>
              : <React.Fragment>
                <FormRow label='Institutions.RelatedPersonType' name='relatedPersonType' target={target} inputType='dropdown' dataSource={context.cache.getRelatedPersonTypes}
                  readonly={isReadonly} required />
                {relatedPersonType && relatedPersonType.code === 'Fndr'
                  ? <FormRow label='Individuals.SharesAmount' name='sharesAmount' target={target} inputType='number' required inputProps={{ min: 0 }} maxValue={decimalMaxChangeItemValue} />
                  : null}
                {relatedPersonType && relatedPersonType.code === 'Brdm'
                  ? <React.Fragment>
                    <FormRow label='Individuals.ContributionAmount' name='contributionAmount' target={target} inputType='number' required inputProps={{ min: 0 }} maxValue={decimalMaxChangeItemValue} />
                    <FormRow label='CodeLists.MembershipType' name='membershipType' target={target} inputType='dropdown' dataSource={() => context.api.codeListService.getCodeList('MembershipType')}
                      readonly={isReadonly} isCodeList required />
                    <FormRow label='CodeLists.DegreeOfMembership' name='degreeOfMembership' target={target} inputType='dropdown' dataSource={() => context.api.codeListService.getCodeList('DegreeOfMembership')}
                      readonly={isReadonly} isCodeList required />
                    <FormRow label='Individuals.IsGeneralManager' name='isGeneralManager' target={target} inputType='checkbox' readonly={isReadonly} />
                  </React.Fragment> : null}
                <ValidDates toKey='Individuals.DateOfLeavingPosition' readonly={isReadonly} />
                <FormRow label='Individuals.NotValidForPurpose' name='notValidForPurpose' readonly={isReadonly} target={target} />
              </React.Fragment>}
          </div>
        </Row>
      </ModalBody>
      <ChangeItemDialogFooter {...props} readonly={isReadonly} />
    </ValidationBoundary>
  )
})

export default {
  component: RelatedPersonDialog
}



// WEBPACK FOOTER //
// ./src/dialogs/relatedPerson.js